import Main from "../components/layout/Main";
import React, {useState} from "react";
import Study from "../containers/CohortBuilder/Study";
import {CohortNavigation} from "../components/cohort-navigation/CohortNavigation";
import {ProjectsPageContext} from "./ProjectsPageContext";

export const StudyPage = () => {
    const [classic, setClassic] = useState<boolean>(false)
    return <ProjectsPageContext.Provider value={{classic, setClassic}}>
        <Main
            title="Cohort Builder"
            containerClassName="white"
            secondaryNavigation={<CohortNavigation showCohortAnalyserSwitch={true}/>}
        >
            <Study/>
        </Main>
    </ProjectsPageContext.Provider>
}
